module.exports = __webpack_public_path__ + "static/media/InstagramRound.4ad9cc14.svg";